import Model from 'src/app/common/model';

export default class UOMMasterModel extends Model {
  name?: string;
  description?: string;
  othername?: string;
  system_uom: boolean;
  uomadded: boolean;

  constructor() {
    super();
  }
}
